<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12 style="text-align: right;">
          <h3 style="float:left">Вопросы</h3>

          <v-btn color="pink" dark small fab @click="openEditingModal()">
            <v-icon>add</v-icon>
          </v-btn>

          <v-btn color="blue" dark small fab @click="refresh()">
            <v-icon>refresh</v-icon>
          </v-btn>
        </v-flex>

        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field flat solo prepend-icon="search" placeholder="Поиск" v-model="search" hide-details
                class="hidden-sm-and-down"></v-text-field>
              <v-btn icon>
                <v-icon>filter_list</v-icon>
              </v-btn>
            </v-toolbar>

            <v-divider></v-divider>

            <v-card-text class="pa-0">
              <v-data-table :headers="headers" :search="search" :items="items" :rows-per-page-items="[25, 50, 100]"
                class="elevation-1" item-key="Id-pollId" no-results-text="Нет результатов"
                rows-per-page-text="На странице" v-model="selectedItems">
                <template slot="items" slot-scope="props">
                  <tr :class="props.item.isActive ? null : 'red lighten-4' || item.posmId ? null : 'green lighten-4'">
                    <td>{{ props.item.Id }}</td>
                    <td class="poll-quest-item-code-cell"><span class="poll-quest-item-code">{{ props.item.code }}</span></td>
                    <td>
                      {{ dataForRender.nameMap.get(props.item.pollId) ? dataForRender.nameMap.get(props.item.pollId) :
            '--' }}</td>
                    <td>{{ dataForRender.extIdMap.get(props.item.pollId) ? dataForRender.extIdMap.get(props.item.pollId)
            :
            '--' }}</td>
                    <td>{{ props.item.name }}</td>
                    <td>{{ dataTypesMap.get(props.item.dataType) ? dataTypesMap.get(props.item.dataType) : '--' }}</td>
                    <td>{{ props.item.posmId ? props.item.posmId : '-'}}</td>
                    <td style="white-space: nowrap;">
                      <v-btn depressed outline icon fab dark color="primary" small
                        @click="openEditingModal(props.item)">
                        <v-icon>edit</v-icon>
                      </v-btn>

                      <!--<v-btn depressed outline icon fab dark color="pink" small @click="openRemovingModal(props.item)">
                        <v-icon>delete</v-icon>
                      </v-btn>-->

                      <v-btn depressed outline icon fab dark color="green" small
                        @click="goToPropertiesPage(props.item)">
                        <v-icon>tune</v-icon>
                      </v-btn>

                      <v-btn v-if="hasAnswers(props.item)" depressed outline icon fab dark color="purple" small
                        @click="goToAnswersPage(props.item)">
                        <v-icon>list</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>

              <!-- Редактирование -->

              <div slot="widget-content">
                <v-dialog v-model="editingModalOpened" persistent max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="headline" v-if="editedIndex !== -1">
                        Редактирование
                      </span>
                      <span class="headline" v-if="editedIndex === -1">
                        Добавление
                      </span>
                    </v-card-title>
                    <div style="overflow-y: scroll; height: 700px; width: 100%;">
                      <v-card-text>
                        <v-form ref="form" v-model="valid" lazy-validation>

                          <!-- ID Вопроса -->
                          <v-layout row>
                            <v-flex xs4>
                              <v-subheader>ID вопроса</v-subheader>
                            </v-flex>
                            <v-flex xs8>
                              <span v-if="readonlyFields">{{ modalData.Id }}</span>
                              <v-text-field v-if="!readonlyFields" label="ID вопроса" v-model="modalData.Id"
                                type="number" :rules="rules.Id"></v-text-field>
                            </v-flex>
                          </v-layout>
                          <!-- Код Вопроса -->
                          <v-layout row v-if="editedIndex !== -1">
                            <v-flex xs4>
                              <v-subheader>Код вопроса</v-subheader>
                            </v-flex>
                            <v-flex xs8>
                              <span v-if="readonlyFields">{{ modalData.code }}</span>
                              <v-text-field readonly v-if="!readonlyFields" label="Код вопроса" v-model="modalData.code"
                                type="text" :rules="rules.code"></v-text-field>
                            </v-flex>
                          </v-layout>
                          <!-- ID анкеты -->
                          <v-layout row>
                            <v-flex xs4>
                              <v-subheader>Анкета</v-subheader>
                            </v-flex>
                            <v-flex xs8>
                              <v-select search-input="" required :rules="rules.required" v-model.lazy="modalData.pollId" :items="pollTemplates"
                                item-text="name" item-value="Id" label="Анкета"></v-select>
                            </v-flex>
                          </v-layout>

                          <!-- Содержание вопроса -->
                          <v-layout row>
                            <v-flex xs4>
                              <v-subheader>Содержание вопроса</v-subheader>
                            </v-flex>
                            <v-flex xs8>
                              <v-text-field label="Содержание вопроса" v-model="modalData.name" :rules="rules.required"
                                required></v-text-field>
                            </v-flex>
                          </v-layout>

                          <!-- Описание методики -->
                          <v-layout row>
                            <v-flex xs4>
                              <v-subheader>Описание методики</v-subheader>
                            </v-flex>
                            <v-flex xs8>
                              <v-text-field label="Описание методики" v-model="modalData.description"></v-text-field>
                            </v-flex>
                          </v-layout>

                          <!-- Тип данных -->
                          <v-layout row>
                            <v-flex xs4>
                              <v-subheader>Тип данных</v-subheader>
                            </v-flex>
                            <v-flex xs8>
                              <v-select v-model="modalData.dataType" required :rules="rules.required" :items="dataTypes" item-text="name" item-value="id"
                                label="Тип данных"></v-select>
                            </v-flex>
                          </v-layout>

                           <!-- POSM -->
                            <v-layout row>
                            <v-flex xs4>
                              <v-subheader>ID привязанного POSM</v-subheader>
                            </v-flex>
                            <v-flex xs8>
                              <v-text-field v-model="modalData.posmId" :rules="rules.posmId"></v-text-field>
                            </v-flex>
                          </v-layout>


                          <!-- // TODO SELECT -->
                          <!-- Вид справочника -->
                          <v-layout row>
                            <v-flex xs4>
                              <v-subheader>Вид справочника</v-subheader>
                            </v-flex>
                            <v-flex xs8>
                              <v-text-field label="Вид справочника" v-model="modalData.refKind"
                                type="number"></v-text-field>
                            </v-flex>
                          </v-layout>

                          <!-- Ключ сортировки -->
                          <v-layout row>
                            <v-flex xs4>
                              <v-subheader>Ключ сортировки</v-subheader>
                            </v-flex>
                            <v-flex xs8>
                              <v-text-field label="Ключ сортировки" v-model="modalData.orderKey"
                                type="number"></v-text-field>
                            </v-flex>
                          </v-layout>

                          <!-- Обязательность заполнения -->
                          <v-layout row>
                            <v-flex xs4>
                              <v-subheader>Обязательнa для заполнения</v-subheader>
                            </v-flex>
                            <v-flex xs8>
                              <v-checkbox label="Обязательнa" v-model="modalData.isRequired"></v-checkbox>
                            </v-flex>
                          </v-layout>

                          <!-- Предыдущий вопрос, ответ на который делает данный вопрос актуальным -->
                          <v-layout row>
                            <v-flex xs4>
                              <v-subheader>Предыдущий вопрос</v-subheader>
                            </v-flex>
                            <v-flex xs8>
                              <v-select search-input="" v-model.lazy="modalData.previousQuestion" :items="items"
                                item-text="name" item-value="Id" label="Предыдущий вопрос" persistent-hint
                                hint="Предыдущий вопрос, ответ на который делает данный вопрос актуальным"></v-select>
                            </v-flex>
                          </v-layout>

                          <!-- Активность вопроса -->
                          <v-layout row>
                            <v-flex xs4>
                              <v-subheader>Активность</v-subheader>
                            </v-flex>
                            <v-flex xs8>
                              <v-switch v-model="modalData.isActive"></v-switch>
                            </v-flex>
                          </v-layout>

                        </v-form>
                      </v-card-text>
                    </div>
                    <v-card-actions>
                      <v-btn flat @click="closeEditingModal()">Закрыть</v-btn>
                      <v-btn color="primary" flat @click="submit">Сохранить</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>

              <!-- Удаление -->
              <div slot="widget-content">
                <v-dialog v-model="removingModalOpened" persistent max-width="500px">
                  <v-card>
                    <v-card-title>
                      <span class="headline">Вы уверены что хотите удалить уровень?</span>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="blue darken-1" flat @click.native="closeRemovingModal()">Отмена</v-btn>
                      <v-btn color="blue darken-1" flat @click.native="remove(modalData);">Да, уверен</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </div>

            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>

export default {
  components: {
  },

  data() {
    return {
      modalData: {},
      oldModalData: {},
      editedIndex: {},
      valid: true,
      readonlyFields: true,
      rules: {
        required: [v => !!v || 'Обязательное поле'],
        Id: [
          v => !!v || 'ID не может быть пустым',
          v => this.items.filter(el => el.Id === v).length === 0 || 'Такой ID уже существует',
        ],
        posmId: [
          v => this.items.filter(el => el.posmId === v).length < 2 || v === null || `Этот POSM уже занят вопросом ${this.items.filter(el => el.posmId === v)[0].Id}`,
        ]
        /*,
        code: [
          v => v.length <= 48 || 'Длина кода может быть не более 48 символов',
          v => !!v || 'Код не заполнен',
        ]*/
      },
      search: '',
      editingModalOpened: false,
      removingModalOpened: false,
      selectedItems: [],
      headers: [
        {
          text: 'ID',
          value: 'Id'
        },
        {
          text: 'Код вопроса',
          value: 'code'
        },
        {
          text: 'Название анкеты',
          value: 'pollName'
        },
        {
          text: 'Внешний ключ анкеты',
          value: 'pollExtId'
        },
        {
          text: 'Вопрос',
          value: 'name'
        },
        {
          text: 'Тип данных',
          value: 'dataType'
        },
        {
          text: 'Привязка POSM',
          value: 'posmId'
        },
        {
          text: 'Действия',
          value: ''
        }
      ],
    };
  },

  mounted: function () {
    if (!this.items.length) {
      this.refresh();
    }

    if (!this.$store.getters['pollTemplates/pollTemplatesData'].length) {
      this.$store.dispatch('pollTemplates/getPollTemplatesData');
    }

    if (!this.$store.getters['dataType/dataTypeList'].length) {
      this.$store.dispatch('dataType/getDataTypeList');
    }
  },

  computed: {
    items() {
      return this.$store.getters['pollQuests/pollQuestsData'];
    },

    posms() {
      return this.$store.getters['posm/items'];
    },

    pollTemplates() {
      return this.$store.getters['pollTemplates/pollTemplatesData'];
    },

    dataTypes() {
      return this.$store.getters['dataType/dataTypeList'];
    },

    dataTypesMap() {
      return this.dataTypes.reduce(
        (acc, dt) => {
          acc.set(dt.id, dt.name);
          return acc;
        },
        new Map()
      );
    },

    posmsMap() {
      return this.posms.reduce(
        (acc, dt) => {
          acc.set(dt.id, dt.name);
          return acc;
        },
        new Map()
      );
    },

    dataForRender() {
      let result = {
        nameMap: new Map(), // Объект Map, содержащий пары "pollId-pollName"
        extIdMap: new Map() // Объект Map, содержащий пары "pollId-pollExtId"
      };

      this.pollTemplates.forEach(poll => {
        result.nameMap.set(poll.Id, poll.name);
        result.extIdMap.set(poll.Id, poll.extId);
      });

      return result;
    },
  },

  methods: {
    refresh() {
      this.$store.dispatch('pollQuests/getPollQuestsData');
    },

    /*generateItemCode() {
      let pollexternalCode = this.dataForRender.extIdMap.get(props.item.pollId) ? dataForRender.extIdMap.get(props.item.pollId) : null;
      return pollexternalCode != null ? pollexternalCode + '-' + props.item.Id : 'Ошибка при генерации кода';
    },*/

    loadModalData(item) {
      if (item !== null && typeof (item) !== 'undefined') {
        this.modalData = item;
        this.oldModalData = Object.assign({}, item);
        this.editedIndex = this.items.indexOf(item);
        this.readonlyFields = true;
      } else {
        const maxId = Math.max.apply(null, (this.items.map(quest => { return quest.Id })));
        this.modalData = {
          Id: maxId + 1,
          pollId: null,
          name: '',
          description: '',
          dataType: null,
          refKind: null,
          orderKey: null,
          isRequired: false,
          previousQuestion: null,
          isActive: false,
          posmId: null,
          //code: ''
        };

        this.oldModalData = {};
        this.editedIndex = -1;
        this.readonlyFields = false;
      }
    },

    openEditingModal(item) {
      this.loadModalData(item);
      this.editingModalOpened = true;
    },

    closeEditingModal() {
      if (this.editedIndex != -1) {
        Object.assign(this.items[this.editedIndex], this.oldModalData);
      }

      this.editingModalOpened = false;
    },

    closeRemovingModal() {
      this.removingModalOpened = false;
    },

    submit() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('pollQuests/savePollQuestsData', { index: this.editedIndex, data: this.modalData })
          .then(() => {
            this.editingModalOpened = false;
            this.refresh();
            this.$store.dispatch('log/getLogData');
          })
      }
    },

    openRemovingModal(data) {
      this.removingModalOpened = true;
      this.modalData = data;
    },

    remove(item) {
      this.$store.dispatch('pollQuests/removePollQuestsData', { item });
      closeRemovingModal();
    },

    goToPropertiesPage(item) {
      this.$store.dispatch('pollQuests/passQuestionParams', { name: item.name, dataType: item.dataType });
      this.$router.push(`/questions/${item.Id}/properties`);
    },

    goToAnswersPage(item) {
      this.$router.push(`/questions/${item.Id}/answers`);
    },

    hasAnswers(item) {
      return [3, 13, 36].includes(item.dataType); // TODO: вынести в настройки
    },
  }
};
</script>

<style>
.layout.row {
  margin-bottom: 20px !important;
}

.v-chip__content {
  cursor: pointer !important;
}

.poll-quest-item-code {
  background: bisque;
  padding: .25em 1em !important;
  height: max-content;
  display: flex;
  width: max-content;
  border-radius: 6px;
  border: 1px solid #0000000a;
  color: #603d13;
}
</style>


// WEBPACK FOOTER //
// src/pages/ui/PollQuests.vue